import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'device-usb', 'DeviceUsb', [["path",{"d":"M7 8h10v8a5 5 0 0 1 -10 0l0 -8"}],["path",{"d":"M9 8v-5h6v5"}]]);